import { Box, ListItem, ListItemText, Typography } from "@material-ui/core";
import { InnerList, OuterList, useListHeaderStyles } from "pages/CreativeMappings/components";
import React from "react";

const filtersCells = [
    { id: "field", numeric: false, disablePadding: false, label: "Field" },
    { id: "operator", numeric: false, disablePadding: false, label: "Operator" },
    { id: "value", numeric: false, disablePadding: false, label: "Value" },
    { id: "logicalOperator", numeric: false, disablePadding: false, label: "Logical" },
];

const creativesCells = [
    { id: "width", numeric: false, disablePadding: false, label: "Width" },
    { id: "height", numeric: false, disablePadding: false, label: "Height" },
    { id: "target", numeric: false, disablePadding: false, label: "Target" },
];

export const ListHeader = () => {
    // TODO: wrap with styled components when possible
    const classes = useListHeaderStyles();

    return (
        // TODO: list item has a button attr bug
        <ListItem className={classes.header}>
            <Typography variant="subtitle1">
                <Box minWidth={40} p={1} mr={0.5} ml={0.5} fontWeight="fontWeightBold">
                    #
                </Box>
            </Typography>
            <OuterList flex={4}>
                <ListItem className={classes.row}>
                    <InnerList>
                        {filtersCells.map(({ id, label }) => (
                            <ListItem key={id} style={{ flex: id === "value" ? 2 : 1 }}>
                                <ListItemText disableTypography={true}>
                                    <Typography variant="subtitle1">
                                        <Box fontWeight="fontWeightBold">{label}</Box>
                                    </Typography>
                                </ListItemText>
                            </ListItem>
                        ))}
                    </InnerList>
                </ListItem>
            </OuterList>
            <OuterList flex={2}>
                <ListItem className={classes.row}>
                    <InnerList>
                        {creativesCells.map(({ id, label }) => (
                            <ListItem key={id}>
                                <ListItemText disableTypography={true}>
                                    <Typography variant="subtitle1">
                                        <Box fontWeight="fontWeightBold">{label}</Box>
                                    </Typography>
                                </ListItemText>
                            </ListItem>
                        ))}
                    </InnerList>
                </ListItem>
            </OuterList>
            <Box flex={0.6} p={2} />
        </ListItem>
    );
};
